import { useCallback, useEffect, useState } from "react";
import * as api from "./billCollection.service";
import { formatIstHistoryTimestamp, classifyHistoryStatusType } from "./pureLogic";

/**
 * Collection History timeline — mirrors central_dashboard's
 * `CollectionHistoryComponent`.
 */
const CollectionHistory = ({ appointmentId }) => {
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);

  const fetchHistory = useCallback(async () => {
    if (!appointmentId) return;
    setLoading(true);
    try {
      const res = await api.getCollectionStatusHistory(appointmentId);
      if (res && (res.status === 200 || res.status === "200")) {
        const rows = Array.isArray(res.data) ? res.data : [];
        setEvents(
          rows.map((row) => ({
            title: row.tag || row.status,
            statusLabel: row.status,
            statusType: classifyHistoryStatusType(row.status),
            remarks: row.remarks || undefined,
            by: row.addedByUsername
              ? row.source
                ? `${row.addedByUsername} (${row.source})`
                : row.addedByUsername
              : row.source || "-",
            timestamp: formatIstHistoryTimestamp(row.addedAt),
            collectionLoss: row.collectionLoss || undefined,
            lossType: row.lossType || undefined,
          }))
        );
      } else {
        setEvents([]);
      }
    } catch {
      setEvents([]);
    } finally {
      setLoading(false);
    }
  }, [appointmentId]);

  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  return (
    <div className="hist-wrap">
      <div className="hist-title">COLLECTION HISTORY</div>

      {loading && <div className="hist-loading">Loading history...</div>}

      {!loading && !events.length && (
        <div className="hist-empty">No collection history yet.</div>
      )}

      {!loading && events.length > 0 && (
        <div className="hist-timeline">
          {events.map((ev, i) => (
            <div className={`hist-item hist-${ev.statusType}`} key={i}>
              <div className="hist-dot" />
              <div className="hist-card">
                <div className="hist-card-head">
                  <span className="hist-card-title">{ev.title}</span>
                  <span className="hist-time">{ev.timestamp}</span>
                </div>

                <div className="hist-status-line">
                  Status changed to
                  <span className="hist-status-pill">{ev.statusLabel}</span>
                </div>

                {ev.collectionLoss && (
                  <div className="hist-loss">
                    <div className="hist-loss-block">
                      <span className="hist-loss-label">COLLECTION LOSS</span>
                      <span className="hist-loss-value">&#8377; {ev.collectionLoss}</span>
                    </div>
                    {ev.lossType && (
                      <div className="hist-loss-block">
                        <span className="hist-loss-label">TYPE</span>
                        <span className="hist-loss-type">{ev.lossType}</span>
                      </div>
                    )}
                  </div>
                )}

                {ev.remarks && (
                  <div className="hist-remarks">
                    <span className="hist-remarks-label">Remarks:</span>{" "}
                    <span className="hist-remarks-text">{ev.remarks}</span>
                  </div>
                )}

                <div className="hist-by">By: {ev.by}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CollectionHistory;
